@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;

    .vm-profile-image {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        overflow: hidden;
        margin: 0;
        aspect-ratio: 1 / 1;

        img {
            display: block;
            width: 100%;
            height: 100%;
            margin: 0;
            object-position: top;
        }

        a {
            position: absolute;
            inset: 0;
            z-index: 1;
        }

        &--initials {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: variables.$fontQuaternary;
            line-height: 1;
            background-color: mixins.get-color(background, bg-gray-100);
            color: mixins.get-color(text, text-white);
            font-weight: 700;
        }
    }
}

:host([size="xs"]) {
    width: 28px;
    height: 28px;
}
// Plain :host makes sm the fallback for an empty or unknown size.
:host,
:host([size="sm"]) {
    width: 40px;
    height: 40px;
}
:host([size="md"]) {
    width: 48px;
    height: 48px;
}
:host([size="lg"]) {
    width: 64px;
    height: 64px;
}

:host([size="xs"]) .vm-profile-image--initials {
    // TODO: use the Stroma Caption/11 token once Stroma typography lands in SCSS.
    font-size: 11px;
}
:host .vm-profile-image--initials,
:host([size="sm"]) .vm-profile-image--initials {
    font-size: mixins.get-font-size(text-md);
}
:host([size="md"]) .vm-profile-image--initials {
    font-size: mixins.get-font-size(text-xl);
}
:host([size="lg"]) .vm-profile-image--initials {
    // TODO: use the Stroma Title/26 token once Stroma typography lands in SCSS.
    font-size: 26px;
}

:host([data-color-index="1"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-teal);
}
:host([data-color-index="2"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-gold);
}
:host([data-color-index="3"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-lavender);
}
:host([data-color-index="4"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-sage);
}
:host([data-color-index="5"]) .vm-profile-image--initials {
    background-color: mixins.get-color(background, bg-brand-sky);
}

:host([fit="fill"]) img {
    object-fit: fill;
}
:host([fit="cover"]) img {
    object-fit: cover;
}
:host([fit="contain"]) img {
    object-fit: contain;
}
:host([fit="none"]) img {
    object-fit: none;
}
:host([fit="scale-down"]) img {
    object-fit: scale-down;
}
